import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { appConfig, clientConfig } from "../../shared/constant/app.constant";
import { AppFlowService } from "../../shared/services/app-flow/app-flow.service";
import { Store, select } from "@ngrx/store";
import { CopyHelpers } from "../../shared/helpers/copy.helpers";
import { ThemeService } from "../../shared/theme/theme.service";

@Component({
  selector: "app-header",
  templateUrl: "./screen-header.component.html",
  styleUrls: ["./screen-header.component.scss"],
})
export class MScreenComponent implements OnInit,OnDestroy{
  brandInfo: BrandingInfo = {
    logoSrc: clientConfig.LOGO_URL, //this.getSampleBase64Image(),
    title: clientConfig.TITLE,
    policyUrl: clientConfig.POLICYURL,
  };
  flowSteps = [];
  returnOrder: any;
  subscription:any;

  constructor(private route: ActivatedRoute, private appFlowService: AppFlowService, private store: Store<AppState>, private router: Router,private themeService: ThemeService) {
    console.log("flow step", appFlowService.activeStepId);
    const activeFlow = this.appFlowService.getActiveAppFlow();
    this.flowSteps = activeFlow.steps;
    console.log("flowservie", appFlowService);
    console.log("flow", activeFlow);
    console.log("step", this.flowSteps);

    this.store.pipe(select("returnOrder")).subscribe((items) => {
      this.returnOrder = CopyHelpers.deepCopy(items);
    });
  }
  @Input() routeurl = "";

  checkIfErrorPage() {
    return this.router && this.router.url ? this.router.url.includes("globalerror") : false;
  }

  ngOnInit() {
    if (clientConfig.MERCHANTCONFIG_IN_DB && clientConfig.MERCHANTCONFIG_IN_DB.toLowerCase().trim() === "true") {
      this.subscription=this.themeService.logo$.subscribe(logo => {
          this.brandInfo.logoSrc = logo.data
      });
    }
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  handleImageError(event:any)
  {
    if (event.target.dataset.errorHandled) {
      return;
    }
      // Handle the error, set a fallback image
      if (clientConfig.MERCHANTNAME.toLowerCase().includes("sony"))
        event.target.src=`${appConfig.NG_APP_ROOT}/assets/i18n/images/sony.png`;
      else if (clientConfig.MERCHANTNAME.toLowerCase().includes("schneider"))
        event.target.src=`${appConfig.NG_APP_ROOT}/assets/i18n/images/schneider.png`;
      else if (clientConfig.MERCHANTNAME.toLowerCase().includes("starlink"))
        event.target.src=`${appConfig.NG_APP_ROOT}/assets/i18n/images/starlink.png`;
      else if (clientConfig.TENANTNAME.toLowerCase().includes("kuehnenagel"))
        event.target.src=`${appConfig.NG_APP_ROOT}/assets/i18n/images/kuehnenagel.png`;
      else
        event.target.src=`${appConfig.NG_APP_ROOT}/assets/i18n/images/centiro.png`;

        event.target.dataset.errorHandled = 'true';
  }
}
